import { render, staticRenderFns } from "./project_edit.vue?vue&type=template&id=1a311e05&scoped=true"
import script from "./project_edit.vue?vue&type=script&lang=js"
export * from "./project_edit.vue?vue&type=script&lang=js"
import style0 from "./project_edit.vue?vue&type=style&index=0&id=1a311e05&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a311e05",
  null
  
)

export default component.exports